// DS: B19.2
import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink, {
  Props as ButtonProps,
} from '@wix/da-shared-react/pkg/Buttons/PlainButtonOrLink';

import s from './HeroEditPrimaryButton.scss';

export interface Props extends ButtonProps {}

export const HeroEditPrimaryButton: React.FC<Props> = ({
  className,
  ...props
}) => (
  <PlainButtonOrLink className={classnames(s['root'], className)} {...props} />
);

HeroEditPrimaryButton.displayName = 'HeroEditPrimaryButton';

export default HeroEditPrimaryButton;
